module.exports = __webpack_public_path__ + "img/SC10-Cover_Costs.8c6cde51.png";